import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";
import fs from "fs";
import path from "path";
import matter from "gray-matter";
import { serialize } from "next-mdx-remote/serialize";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import CookiesPolicyComponent from "@/containers/CookiesPolicy";

interface GetStaticProps {
  locale: string;
}

interface CookiesPolicyProps {
  content: MDXRemoteSerializeResult;
  metadata: {
    title: string;
    description: string;
  };
}

const CookiesPolicy = ({ content, metadata }: CookiesPolicyProps) => {
  return <CookiesPolicyComponent content={content} metadata={metadata} />;
};

export const getStaticProps = async ({ locale }: GetStaticProps) => {
  const markdownWithMeta = fs.readFileSync(
    path.join(`src/containers/CookiesPolicy/${locale}.md`),
    "utf-8"
  );
  const { content, data: metadata } = matter(markdownWithMeta);
  const mdxContent = await serialize(content);
  return {
    props: {
      content: mdxContent,
      metadata,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

export default CookiesPolicy;
